export default "__VITE_ASSET__B_m5k76n__"